import React, { useContext, useState, useEffect } from 'react'
import ClassNames from 'classnames'
import Panel from 'Atoms/Panel'
import Button from 'Molecules/Button'
import Typography from 'Atoms/Typography'
import Image from 'next/image'
import AutoComplete from 'Atoms/Form/Elements/AutoComplete'

import { VehicleContext } from 'Contexts/VehicleContext'
import { FetchRaceTypes, AddUserVehicle, getPropperUrl } from 'Contexts/VehicleContext/CoreVehicleRequests'
import { UserContext } from 'Contexts/UserContext/UserContext'
import { ThemeContext } from 'Contexts/ThemeContext'


import styles from '../YmmModal.module.scss'
import useSegment from '../../../../Hooks/useSegment/useSegment'
import { createFitmentAddedSegmentEvent } from '../../../../Utilities/Instrumentation/Fitment/fitmentSegmentEvents'
import { addRaceCarEvent } from '../../../../Utilities/Instrumentation/Fitment/fitmentGaEvents'
import useGoogleAnalytics from 'Hooks/useGoogleAnalytics'

const RaceTypeTab = ({ isEnabled, services, isProductPage }) => {
    if (!isEnabled) {
        return null
    }

    const { context: vehicleState, UpdateRaceTypes } = useContext(VehicleContext)
    const { context: userState, updateUserGuid } = useContext(UserContext)
    const { setIsLoading } = useContext(ThemeContext)
    const { sendCustomSegmentTrackEvent, sendSegmentTrackEventWithName } = useSegment()
    const { sendGoogleAnalyticsEvent } = useGoogleAnalytics()

    const options = []

    vehicleState.raceTypes?.forEach((raceType) => {
        options.push({
            label: raceType?.displayName,
            value: raceType?.raceTypeId
        })
    })

    useEffect(() => {
        async function fetchAllRaceTypes() {
            var response = await FetchRaceTypes(vehicleState, services?.traits?.url, vehicleState?.selectedFacetData)
            if (response) {
                response.raceTypeLinks.sort(
                    (raceType1, raceType2) => {
                        if (raceType1.priority > raceType2.priority) {
                            return 1;
                        }
                        if (raceType2.priority > raceType1.priority) {
                            return -1
                        }
                        return 0
                    }
                )
                UpdateRaceTypes(response, vehicleState.selectedVehicle?.raceTypeId)
            }
        }

        fetchAllRaceTypes()

    }, [isEnabled])

    return (
        <Panel className={styles.modalPanel}>
            <div className={`${ClassNames(styles.raceTab, styles.ymmContainer)} lr-RaceSelector`}>
                <div
                    className={ClassNames(
                        styles.ymmModalItem,
                        styles.raceTypes
                    )}
                >
                    <AutoComplete
                        options={options}
                        onChange={async (event) => {
                            AddNewRaceTypeToGarage(event.value, userState.userGuid, vehicleState, services?.customerVehicles?.url, updateUserGuid, UpdateRaceTypes, setIsLoading, isProductPage, vehicleState?.selectedFacetData, sendSegmentTrackEventWithName, sendGoogleAnalyticsEvent)
                        }}
                        label={'Select Your Race Car'}
                        selectedValue={vehicleState.selectedVehicle?.raceTypeId != null ? { value: vehicleState.selectedVehicle?.raceTypeId, label: vehicleState.selectedVehicle?.raceDisplay } : null}
                        isDisabled={false}
                        placeholder={'Race Car'}
                    />
                </div>
                <Button
                    className={styles.addRaceTypeButton}
                    size={'small'}
                    intent={'action'}
                    fill
                    onClick={() => {     
                        if (vehicleState.selectedVehicle?.raceTypeId !== null)
                            window.location.href=getPropperUrl(vehicleState.selectedVehicle)                      
                    }}
                    gaEvent={addRaceCarEvent}
                    type={'button'}
                    disabled={vehicleState.selectedVehicle?.raceTypeId === null}
                    text={'Add Race Car'}
                />
            </div>
            <div
                className={ClassNames(
                    styles.hideMobile,
                    styles.raceTypeImageContainer
                )}
            >
                {vehicleState.raceTypes?.map((raceType) => {
                    return (
                        <div
                            key={raceType.displayName}
                            className={styles.raceTypeListItem}
                            onClick={async (event) => {
                                AddNewRaceTypeToGarage(raceType.raceTypeId, userState.userGuid, vehicleState, services?.customerVehicles?.url, updateUserGuid, UpdateRaceTypes, setIsLoading, isProductPage, vehicleState?.selectedFacetData, sendCustomSegmentTrackEvent, sendGoogleAnalyticsEvent)
                            }}
                        >
                            <Typography
                                size={1}
                                font={'heading'}
                                inline
                                className={styles.raceTypeText}
                            >
                                {raceType.displayName}
                            </Typography>
                            <Image
                                src={raceType.imageUrl}
                                alt={raceType.displayName}
                                layout={'fill'}
                                className={styles.raceTypeImage}
                            ></Image>
                        </div>
                    )
                })}
            </div>
        </Panel>
    )
}

async function AddNewRaceTypeToGarage(selectedRaceTypeId, userGuid, vehicleState, url, updateUserGuid, UpdateRaceTypes, setIsLoading, isProductPage, selectedFacetData, sendCustomSegmentTrackEvent, sendGoogleAnalyticsEvent) {
    try {
        setIsLoading(true)
        const racetTypeId = parseInt(selectedRaceTypeId, 10)
        const raceType = vehicleState?.raceTypes.find(raceType => raceType.raceTypeId === racetTypeId)

        var response = await AddUserVehicle(userGuid, url, null, null, null, racetTypeId, null, selectedFacetData)

        if (!response) {
            setIsLoading(false)
        }

        if (response?.addNewProjectToGarage?.success && !response?.addNewProjectToGarage?.alreadyExisted) {
            const segmentEvent = createFitmentAddedSegmentEvent(null, null, null, null, null, racetTypeId, raceType?.displayName);
            sendCustomSegmentTrackEvent(segmentEvent)
            sendGoogleAnalyticsEvent(addRaceCarEvent)
        }

        const user = response?.addNewProjectToGarage?.webUser
        await UpdateRaceTypes(vehicleState.raceTypes, racetTypeId, response?.addNewProjectToGarage?.projects)
        if (user?.userGuid) {
            updateUserGuid(user?.userGuid)
        }

        let racecar = vehicleState.raceTypes ? vehicleState.raceTypes.find((x) => x.raceTypeId === racetTypeId) : null

        if (racecar) {
            if (isProductPage) {
                window.location.reload()
                return false
            }
            else {
                window.location.href = getPropperUrl(racecar)
            }
        }
        else {
            throw "Unable to find racecar in vehicle state"
        }
    }
    catch (err) {
        console.error('Unable to add race vehicle to garage', err, vehicleState)
        setIsLoading(false)
    }
}
export default RaceTypeTab
